import { connect } from 'react-redux';

import { Actions as LoginActions } from 'modules/login';

import PlatformList from './platform-list.component';
import { externalLoginOptionType } from 'modules/ubisoft-connect-service/constants';
import { Dispatch } from 'types/dispatch';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    openPlatformLoginPopup: (externalLoginOption: externalLoginOptionType) => {
        dispatch(LoginActions.openLoginPopup(externalLoginOption));
    }
});

const PlatformListContainer = connect(
    null,
    mapDispatchToProps
)(PlatformList);

export default PlatformListContainer;
